module.exports = __webpack_public_path__ + "images/landing/argus-logo.png";